export { default as SectorRotationTable } from './component';
